__turbopack_context__.v({
  "wrapper": "AuthorSocialMedia-module-scss-module__yLOw6W__wrapper",
});
